import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { rgba } from 'polished';
import css from '@styled-system/css';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { isFunction } from './assertions.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var get = function get(obj, path, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = null;
  }

  var result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce(function (res, key) {
    return res !== null && res !== void 0 ? res[key] : res;
  }, obj);
  return result === void 0 || result === obj ? defaultValue : result;
};

var themeGet = function themeGet(props, path) {
  var value = get(props.theme, path);
  return isFunction(value) ? value(props) : value;
};

var stripUnit = function stripUnit(str) {
  return parseFloat(str);
};

var token = function token(path) {
  return function (props) {
    return themeGet(props, path);
  };
};

var color = function color(path, opacity2) {
  if (opacity2 === void 0) {
    opacity2 = 1;
  }

  return function (props) {
    return rgba(themeGet(props, "colors." + path), opacity2);
  };
};

var opacity = function opacity(path) {
  return function (props) {
    return themeGet(props, "opacities." + path);
  };
};

var palette = color;

var baseUnit = function baseUnit(multiplier) {
  return function (_ref) {
    var theme = _ref.theme;
    return theme.baseUnit(multiplier);
  };
};

var spacing = function spacing(size, options) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return theme.spacing(size, options);
  };
};

var fontSize = function fontSize(size) {
  return function (props) {
    return themeGet(props, "fontSizes." + size);
  };
};

var lineHeight = function lineHeight(size) {
  return function (props) {
    return themeGet(props, "lineHeights." + size);
  };
};

var fontWeight = function fontWeight(weight) {
  return function (props) {
    return themeGet(props, "fontWeights." + weight);
  };
};

var radius = function radius(radius2) {
  return function (props) {
    return themeGet(props, "radii." + radius2);
  };
};

var shadow = function shadow(shadow2) {
  return function (props) {
    return themeGet(props, "shadows." + shadow2);
  };
};

var component = function component(path) {
  return function (props) {
    return themeGet(props, "components." + path);
  };
};

var border = function border(type) {
  return function (props) {
    return themeGet(props, "borders." + type);
  };
};

var zIndex = function zIndex(zIndex2) {
  return function (props) {
    return Number(themeGet(props, "zIndices." + zIndex2));
  };
};

var breakpoint = function breakpoint(breakpoint2) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return theme.breakpoint(breakpoint2);
  };
};

var getThemeModeValue = function getThemeModeValue(props, values) {
  var mode = props && props.theme && props.theme.mode;
  var themeValue = typeof mode === "function" ? mode(values) : values[mode];
  return typeof themeValue === "function" ? themeValue(props) : themeValue;
};

var themeMode = function themeMode(values) {
  return function (props) {
    return getThemeModeValue(props, values);
  };
};

var parseStyles = function parseStyles(styles) {
  return function (props) {
    if (!styles) {
      return;
    }

    return Object.entries(styles).reduce(function (acc, _ref4) {
      var key = _ref4[0],
          value = _ref4[1];

      if (typeof value === "object") {
        if (key in props && typeof props[key] === "boolean" && !!props[key]) {
          acc = __spreadValues(__spreadValues({}, acc), parseStyles(value)(props));
          return acc;
        }

        acc[key] = parseStyles(value)(props);
        return acc;
      }

      acc[key] = typeof value === "function" ? value(props) : value;
      return acc;
    }, {});
  };
};

var extractStyles = function extractStyles(props, variantValues, theme) {
  var variantStyles = typeof variantValues === "function" ? variantValues(props) : variantValues;
  var flattenedValues = parseStyles(variantStyles)(props);
  return css(flattenedValues)(theme);
};

var variant = function variant(_ref5) {
  var prop = _ref5.prop,
      compoundProp = _ref5.compoundProp,
      variants = _ref5.variants;
  return function (props) {
    var _a;

    var theme = props.theme;
    var compiledStyles = {};
    var propValue = props[prop];
    var variantValues = variants == null ? void 0 : variants[propValue];
    var extractedStyles = extractStyles(props, variantValues, theme);
    compiledStyles = __spreadValues(__spreadValues({}, compiledStyles), extractedStyles);

    if (compoundProp) {
      var compoundPropValue = props[compoundProp];
      var variantValues2 = (_a = variants == null ? void 0 : variants[propValue]) == null ? void 0 : _a[compoundPropValue];
      var extractedStyles2 = extractStyles(props, variantValues2, theme);
      compiledStyles = __spreadValues(__spreadValues({}, compiledStyles), extractedStyles2);
    }

    var finalStyles = Object.entries(compiledStyles).reduce(function (acc, _ref6) {
      var key = _ref6[0],
          value = _ref6[1];
      var x = isFunction(value) ? value(props) : value;
      acc[key] = x;
      return acc;
    }, {});
    var finalCompileStyles = css(finalStyles)(theme);
    return finalCompileStyles;
  };
};

var useStyles = function useStyles(_ref7) {
  var styles = _ref7.styles,
      props = _ref7.props;
  var themeContext = useContext(ThemeContext);
  return styles(__spreadValues({
    theme: themeContext
  }, props));
};

export { baseUnit, border, breakpoint, color, component, fontSize, fontWeight, get, lineHeight, opacity, palette, radius, shadow, spacing, stripUnit, themeMode, token, useStyles, variant, zIndex };